import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API_URLS } from '../Utils/Constants';
import AppNavbar from "../Navbar/Navbar";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import '../Style/AddCandidate.css';

const AddCandidate = () => {
    const { id } = useParams();
    const [name, setName] = useState('');
    const [image, setImage] = useState(null);
    const [description, setDescription] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            navigate('/login');
        }
    }, [navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!name || !image || !description) {
            setError('Por favor, rellena todos los campos.');
            return;
        }

        const formData = new FormData();
        formData.append('name', name);
        formData.append('image', image);
        formData.append('description', description);
        formData.append('campaign_id', id);

        try {
            const token = localStorage.getItem('token');

            const requestOptions = {
                method: 'POST',
                headers: {
                    'Authorization': `${token}`,
                },
                body: formData
            }

            const response = await fetch(`${API_URLS.BASE_PATH}/api/candidate`, requestOptions);

            const data = await response.json();

            if (response.ok) {
                navigate(`/campaign/${id}`);
            } else if (response.status === 403 || response.status === 401) {
                console.error('Token invalido o expirado');
                localStorage.removeItem('token');
                navigate('/login');
            } else {
                setError(data.error || 'Error al agregar el candidato.');
            }
        } catch (error) {
            console.error('Error al decodificar el token', error);
            navigate('/login');
        }
    };

    const handleImageChange = (e) => {
        setImage(e.target.files[0]); // Guardar el archivo seleccionado
    };

    return (
        <div className="add-candidate-page">
            <AppNavbar />
            <div className="add-candidate-container">
                <h1>Agregar Candidato</h1>
                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="name" className="mb-3">
                        <Form.Label>Nombre del Candidato</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Introduce el nombre"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </Form.Group>

                    <Form.Group controlId="image" className="mb-3">
                        <Form.Label>Imagen del Candidato</Form.Label>
                        <Form.Control
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                        />
                    </Form.Group>

                    <Form.Group controlId="description" className="mb-3">
                        <Form.Label>Descripción del Candidato</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Introduce la descripción"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </Form.Group>

                    {error && <p className="text-danger">{error}</p>}

                    <Button variant="primary" type="submit">
                        Agregar Candidato
                    </Button>
                </Form>
            </div>
        </div>
    );
};

export default AddCandidate;
